export default __webpack_public_path__ + "static/media/Facebook-blue.dcf309d6.svg";